<template>
  <div
    v-track:impression="{
      event: 'imageCarousel:displayed',
      args: [teasers],
    }"
    class="w-full flex flex-col sm:flex-row sm:flex-wrap gap-6 justify-center"
  >
    <div
      v-for="({ image, link }, index) in teasers"
      :key="index"
      class="relative rounded-lg overflow-hidden h-40"
      :class="size === 'sm' ? 'h-40' : 'h-72'"
      :style="{ width: screen.isExtraSmall ? '100%' : 'calc(33.33% - 1.5rem)' }"
    >
      <WebccLink
        :to="link.href"
        :anchor="true"
        :target="getLinkTarget(link)"
        @click="trackItemClick(index)"
      >
        <img
          :src="image.src"
          :alt="image.alt"
          :copyright="image.copyright"
          class="object-cover h-full w-full cursor-pointer"
        />
        <div
          v-if="link.href"
          class="absolute w-full bottom-0 h-[2.5rem] text-black bg-white flex items-center justify-center"
        >
          <span class="text-center text-bold underline text-l">{{
            link.text
          }}</span>
        </div>
      </WebccLink>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  teasers: LandingImageCarouselTeaser[]
  size: 'sm' | 'lg'
}>()

const tracking = useTracking()

const screen = useScreen()

const trackItemClick = (index: number) => {
  tracking.handlers?.imageCarousel.view(props.teasers[index].link.text, index)
}
</script>
